import React, { useEffect, useState } from 'react'
import ConsultasFormularios from '../Sql/ConsultasFormularios';
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import ConsultasComunes from '../Sql/ConsultasComunes';
import BuscarEmpleado from '../BuscarEmpleado';

function EditarDestinoFormulario(props) {
    const { selectExamen,collback } = props;
    const [destinos, setDestinos] = useState(selectExamen.DESTINOS);
    const [idEncuesta,setIdEncuenta] = useState(selectExamen.ID_ENCUESTA)
    const [alcances, setAlcances] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [idAlcance,setIdAlcance] = useState(0);
    const [regional,setRegional] = useState();
    const [lista,setLista] = useState([]);
    function eliminarDestio(valor) {
        var valorFiltrado = destinos.filter((item) => item.VALOR != valor.VALOR);
        var eliminado = destinos.filter((item) => item.ID_ALCANCE == valor.ID_ALCANCE && item.VALOR == valor.VALOR);
        eliminado[0].ESTADO = false;
        setDestinos([...valorFiltrado, ...eliminado])
    }
    const agregarDestinatarios = async(valor)=>{
        console.log(valor)
        if(valor<=3){
            setIdAlcance(valor)
            var hayDestino = destinos.filter((item)=>item.ID_ALCANCE==valor&& item.ESTADO==true);
            if(hayDestino.length==0){
                switch (valor){
                    case '1':
                        setDestinos([...destinos,{'ID_ENCUESTA':idEncuesta,'VALOR':0,'ID_ALCANCE':valor,'DESCRIPCION':'TODOS','ESTADO':true}])
                        break;
                    case '2':
                        setDestinos([...destinos,{'ID_ENCUESTA':idEncuesta,'VALOR':1,'ID_ALCANCE':valor,'DESCRIPCION':'SUPERVISION','ESTADO':true}])
                        break;
                    case '3':
                        setDestinos([...destinos,{'ID_ENCUESTA':idEncuesta,'VALOR':regional,'ID_ALCANCE':valor,'DESCRIPCION':regional=='990'?'CBBA':'SCRZ','ESTADO':true}])
                        break;
                } 
            }else{
                MsgUtils.msgError("El destino ya existe")
            }
        }else{
            if(valor>=4 && valor<=7){
                try {
                    var datos;
                    switch (valor){
                        case '4'://sucursales
                            datos = await ConsultasComunes.getSucursales(regional);
                            break;
                        case '5'://areas
                            datos = await ConsultasComunes.getInfoCategoriasSys({regional,'tipo':'PL'});
                            break;
                        case '6'://departamento
                            datos = await ConsultasComunes.getInfoCategoriasSys({regional,'tipo':'DE'});
                            break;
                        case '7'://cargo
                            datos = await ConsultasComunes.getInfoCategoriasSys({regional,'tipo':'TC'});
                            break;
                    }
                    if(datos.ok){
                        setIdAlcance(valor);
                        setLista(datos.ok);
                        setShowModal(true);
                    }else{
                        MsgUtils.msgError(datos.error);
                    }    
                } catch (error) {
                    MsgUtils.msgError(error.message);
                }
            }else{
                setIdAlcance(valor);
                setShowModal(true);
            }
        }
    }
    function agregarValorDestino(valor){
        console.log(valor)
        var info,dato;
        if(idAlcance==4){
            info=lista.filter((item)=>item.ID_SUCURSAL==valor)[0].SUCURSAL;
            dato = valor;
        }else if(idAlcance>=5&&idAlcance<=7){
            info=lista.filter((item)=>item.ID_CATEGORIA==valor)[0].CATEGORIA;
            dato = valor;
        }else{
            info=valor.NOMBREX;
            dato = valor.ID_EMPLEADO;
        }
        var hayDestino = destinos.filter((item)=>item.VALOR==dato);
        setShowModal(false);
        if(hayDestino.length==0){
            setDestinos([...destinos,{'ID_ENCUESTA':idEncuesta,'VALOR':dato,'ID_ALCANCE':idAlcance,'DESCRIPCION':info,'ESTADO':true}]);
        }else{
            MsgUtils.msgError("Ya se encuentra el destino "+info)
        }
    }
    const obtenerAlcances = async () => {
        try {
            var regional = JSON.parse(localStorage.getItem('__react_session__')).regional;
            setRegional(regional);
            var data = await ConsultasFormularios.getAlcanceFormulario({ regional });
            if (data.ok) {
                console.log(data.ok)
                setAlcances(data.ok);
            } else {
                MsgUtils.msgError(data.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const guardarEdicionDestino=async()=>{
        try {
            var bindig={
                'regional':regional,
                'idEncuesta':idEncuesta,
                'destinos':destinos
            }
            var resultado= await ConsultasFormularios.editarAlcanceFormulario(bindig);
            if(resultado.ok){
                collback()
                MsgUtils.msgCorrecto(resultado.ok);
            }else{
                MsgUtils.msgError(resultado.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(() => {
        if (alcances.length == 0) {
            obtenerAlcances();
        }
    })
    return (
        <div className='container-fluid'>
            <div className='row row-cols g-1'>
                <div className='col-9'>
                    <div className='text-center text-light'>{selectExamen.TITULO}</div>
                    <div className='mb-3 overflow-auto bg-light' style={{ maxHeight: '120px' }}>
                        {destinos.map((item, index) => {
                            if (item.ESTADO == true) {
                                return (
                                    <div className='container-fluid bg-dark bg-gradient border border-light' key={index}>
                                        <div className='row row-cols g-1 m-0 p-0 '>
                                            <div className='col-10 my-auto text-light fw-bold'>
                                                {item.DESCRIPCION}
                                            </div>
                                            <div className='col-2 my-auto'>
                                                <button className='btn btn-sm btn-transparent text-danger'
                                                    onClick={() => eliminarDestio(item)}>
                                                    <i className="fa-solid fa-trash-can"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </div>
                <div className='col-3'>
                    <div className='text-light fw-bold'>Agregar</div>
                    <div className="mb-3">
                        <label className="form-label text-light">Alcance De la Encuesta</label>
                        <select className="form-select form-select-sm" value={-1}
                            onChange={(e) => agregarDestinatarios(e.target.value)}>
                            <option value={-1} selected>NINGUNO</option>
                            {alcances.map((item, index) => {
                                return (
                                    <option value={item.ID_ALCANCE} key={index}>{item.DESCRIPCION}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
            </div>
            <div className='tex-end'>
                <button className='btn btn-success btn-sm' onClick={()=>guardarEdicionDestino()}><i className="fa-solid fa-floppy-disk"></i> Guardar</button>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}
                size="md" backdrop="static"
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-secondary bg-gradient' centered>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Agregar </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    {idAlcance == 4 &&
                        <div className='container-fluid'>
                            <div className='text-light fw-bold text-center'>
                                Elegir la Sucursal
                            </div>
                            <select className="form-select form-select-sm"
                                onChange={(e) => { agregarValorDestino(e.target.value) }}>
                                <option value={-1} selected>NINGUNO</option>
                                {lista.map((item, index) => {
                                    return (
                                        <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    }
                    {(idAlcance == 5 || idAlcance == 6 || idAlcance == 7) &&
                        <div className='container-fluid'>
                            <div className='text-light fw-bold text-center'>
                                Elegir la categoria
                            </div>
                            <select className="form-select form-select-sm"
                                onChange={(e) => { agregarValorDestino(e.target.value) }}>
                                <option value={-1} selected>NINGUNO</option>
                                {lista.map((item, index) => {
                                    return (
                                        <option value={item.ID_CATEGORIA} key={index}>{item.CATEGORIA}</option>
                                    )
                                })}
                            </select>
                        </div>
                    }
                    {idAlcance == 8 &&
                        <BuscarEmpleado setShowModal1={setShowModal} setColaborador={agregarValorDestino} reg={regional} />
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default EditarDestinoFormulario